import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateCropExplorationTemplate } from "services";

import { GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES, UPDATE_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useUpdateCropExplorationTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_CROP_EXPLORATION_TEMPLATES],
    mutationFn: updateCropExplorationTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
